import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SizeInformer from '~/views/Home/base/SizeInformer';
import isEqual from 'lodash.isequal';
import debounce from 'lodash.debounce';

const MIN_SCORE_FONT_SIZE = 15;
const MAX_SCORE_FONT_SIZE = 24;

export default
class TimedSizeFinder extends Component {
    static propTypes = {
        i: PropTypes.number.isRequired,
        testData: PropTypes.object.isRequired,
        columns: PropTypes.object.isRequired,
        roundConfig: PropTypes.object.isRequired,
        deviceType: PropTypes.string.isRequired
    }

    state = {
        lastUpdate: new Date(0),
        nameWidth: 0,
        fontSize: MAX_SCORE_FONT_SIZE
    }

    componentWillUnmount() {
        this.noFontSizer = null;
        this.nameFontSizer = null;
        this.scoreFontSizer = null;
        this.sizeFinder = null;
    }

    getSnapshotBeforeUpdate(prevProps) {
        if (Object.keys(prevProps).length !== Object.keys(this.props).length) {
            this.setState({
                lastUpdate: new Date()
            });

            return true;
        }

        let paramsChanged = false;

        for (let key in this.props) {
            if (key === 'children') {
                continue;
            }

            paramsChanged = paramsChanged || !isEqual(
                this.props[key],
                prevProps[key]
            );
        }

        if (paramsChanged) {
            this.setState({
                lastUpdate: new Date()
            });
        }

        return paramsChanged;
    }

    loaded = false

    componentDidUpdate() {
        if (this.loaded) {
            return;
        }

        setTimeout(() => {
            this.setState({
                lastUpdate: new Date()
            });
        }, 100);

        this.loaded = true;
    }

    hasEnoughSpace = () => {
        if (!this.sizeFinder) {
            return false;
        }

        const {
            clientWidth: fullWidth,
            scrollWidth: fullScrollWidth
        } = this.sizeFinder;

        return fullScrollWidth <= fullWidth;
    }

    calculateSizes = debounce(() => {
        let i = 1;
        let fontSize = MAX_SCORE_FONT_SIZE;

        this.noFontSizer.style.fontSize = `${fontSize}px`;
        this.nameFontSizer.style.fontSize = `${fontSize}px`;
        this.scoreFontSizer.style.fontSize = `${fontSize}px`;

        while (!this.hasEnoughSpace() && i < 100) {
            if (--fontSize < MAX_SCORE_FONT_SIZE) {
                fontSize = MIN_SCORE_FONT_SIZE;
                break;
            }

            this.noFontSizer.style.fontSize = `${fontSize}px`;
            this.nameFontSizer.style.fontSize = `${fontSize}px`;
            this.scoreFontSizer.style.fontSize = `${fontSize}px`;

            ++i;
        }

        this.noFontSizer.style.fontSize = `${fontSize}px`;
        this.nameFontSizer.style.fontSize = `${fontSize}px`;
        this.scoreFontSizer.style.fontSize = `${fontSize}px`;

        this.setState({
            nameWidth: this.nameFontSizer.clientWidth,
            fontSize
        });
    })

    render() {
        const {
            i,
            testData: {
                longestAthleteName,
                longestScore
            },
            columns,
            children
        } = this.props;

        const {
            lastUpdate,
            nameWidth,
            fontSize
        } = this.state;

        return [
            <div
                key={`leaderboard_timed_group_size_finder_${i}`}
                className="size-finder"
                ref={ref => this.sizeFinder = ref}
            >
                <SizeInformer
                    className="row row-timed sizer-row"
                    onResized={this.calculateSizes}
                    lastUpdate={lastUpdate}
                >
                    <div
                        className="cell cell-no"
                        ref={ref => this.noFontSizer = ref}
                    >
                        00
                    </div>

                    {columns.Bib &&
                        <div className="cell cell-bib">
                            WWW
                        </div>
                    }

                    <div className="cell cell-name">
                        <div
                            ref={ref => this.nameFontSizer = ref}
                        >
                            {longestAthleteName}
                            {columns.Nation &&
                            <div className="nation">
                                WWW
                            </div>
                            }
                        </div>
                    </div>

                    <div className="cell cell-scores">
                        <div
                            className="score-item"
                            ref={ref => this.scoreFontSizer = ref}
                        >
                            {longestScore}
                        </div>
                    </div>
                </SizeInformer>
            </div>,

            children({
                className: '',
                noStyle: {
                    fontSize
                },
                nameStyle: {
                    minWidth: nameWidth,
                    fontSize
                },
                scoreStyle: {
                    fontSize
                }
            })
        ];
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/table/TableLeaderboard/timed/SizeFinder.js